import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
const apiUrl = process.env.REACT_APP_API_URL;

class TableBody extends Component {
  getCategoryBackground = (value) => {
    switch (value) {
      case "feature-request":
        return "#ff5b57";
      case "disconnection":
      case "complaint":
        return "#f1c40f";
      case "bug-error":
      case "orders":
        return "#2ecc71";
      case "sales":
        return "#2b9fc1";
      default:
        return "white";
    }
  };

  getPriorityBackground = (value) => {
    switch (value) {
      case "urgent":
        return "#ff5b57";
      case "high":
        return "#f1c40f";
      case "normal":
        return "#2ecc71";
      case "low":
        return "#2b9fc1";
      default:
        return "white";
    }
  };

  getStatusBackground = (value) => {
    switch (value) {
      case "open":
        return "#2ECC71";
      case "onhold":
        return "black";
      case "closed":
        return "gray";
      case "reopen":
        return "#BFFF00";
      case "pending":
        return "red";
      default:
        return "#2b9fc1";
    }
  };

  getStatusLeaveBackground = (value) => {
    switch (value) {
      case "pending":
        return "#2ECC71";
      case "approved":
        return "black";
      case "canceled":
        return "gray";
      default:
        return "#2b9fc1";
    }
  };

  renderCell(item, column) {
    const cellValue = _.get(item, column.path, "-");

    if (
      column.path === "expiredDate" ||
      column.path === "validTill"
    )
      return moment(cellValue).format("L");

    if (
      column.path === "deadline" ||
      column.path === "startDate" ||
      column.path === "endDate"
    )
      return cellValue ? moment(cellValue).format("L, h:mm A") : "-";

    if (column.path === "color") {
      return (
        <div
          style={{
            backgroundColor: item.color,
            padding: "6px 12px",
            whiteSpace: "nowrap",
            color: "white",
            fontWeight: "500",
            borderRadius: "5px",
          }}
        >
          {column.content ? column.content(item) : cellValue}
        </div>
      );
    }

    if (column.content) return column.content(item);
    if (cellValue === true) return "Yes";
    if (cellValue === false) return "No";

    return cellValue;
  }

  productImage = (item, column) => {
    return (
      <div>
        <Image
          style={styles.productImage}
          src={
            item.user.imageSrc || `${apiUrl}/${item?.productImage[0]?.filePath}`
          }
          alt="product image"
          width={20}
        />
        <span>{item.businessNo.companyInfo.businessName}</span>
      </div>
    );
  };
  userImage = (item, column) => {
    console.log(item);
    return (
      <div>
        <Image
          style={styles.productImage}
          src={
            item.userID?.imageSrc ||
            `${apiUrl}/${item?.productImage[0]?.filePath}`
          }
          alt="product image"
          width={20}
        />
        <span>{item.userID.username}</span>
      </div>
    );
  };
  renderCustomCell = (item, column) => {
    const cellValue = _.get(item, column.path, "status");

    let backgroundColor;
    if (column.path === "category") {
      backgroundColor = this.getCategoryBackground(cellValue);
    } else if (column.path === "priority") {
      backgroundColor = this.getPriorityBackground(cellValue);
    } else if (column.path === "status") {
      backgroundColor = this.getStatusBackground(cellValue);
    }

    return (
      <div
        style={{
          backgroundColor,
          padding: "6px 12px",
          whiteSpace: "nowrap",
          color: "black",
          fontWeight: "500",
          borderRadius: "5px",
        }}
      >
        {column.content ? column.content(item) : cellValue}
      </div>
    );
  };

  createKey(item, column) {
    return item._id + (column.path || column.key);
  }

  render() {
    const { data, columns } = this.props;

    return (
      <tbody>
        {data.map((item) => (
          <tr key={item._id}>
            {columns.map((column) => (
              <td key={this.createKey(item, column)}>
                {column.path === "category" ||
                column.path === "priority" ||
                column.path === "status"
                  ? this.renderCustomCell(item, column)
                  : column.path === "image"
                  ? this.productImage(item, column)
                  : column.label === "owner"
                  ? this.userImage(item, column)
                  : this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

TableBody.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

const styles = {
  productImage: {
    maxHeight: "50px",
    maxWidth: "50px",
    cursor: "pointer",
  },
};

export default TableBody;
